
import * as jotoTypes from "./api/joto-types";
import * as joto from './api/joto';
import produce from "immer";
import {persistReducer, persistStore} from "redux-persist";

import { store  as reactNotificationsComponentStore} from 'react-notifications-component';

// import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session'
import { PersistGate } from 'redux-persist/integration/react';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
// https://github.com/rt2zz/redux-persist/issues/126 Delay Render Until Rehydration Complete
import { REHYDRATE} from "redux-persist/es/constants";

import { Provider as ReduxProvider} from 'react-redux'; // , connect, useSelector

import * as jotouiutils from './components/JotoUIUtils'


import * as redux from "redux"; // {createStore, Store}
import React from "react";

import {Normalize as SmoothUINormalize} from '@smooth-ui/core-sc';

import merge from 'lodash/merge';

import * as log from 'loglevel';
import * as env from "./env";

export const successNotificationTimeout = 2500;
export const failureNotificationTimeout = 10000;

export const likeNotLoggedInMessage : [string, string] = ['Like', 'Du bist nicht eingelogged. Deshalb kannst Du den Like-Button nicht aufrufen. Log Dich ein um ein Projekt zu liken.'];

// log.setDefaultLevel(log.levels.DEBUG);
// noinspection JSUnusedLocalSymbols
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = log.getLogger('joto-ui-api.tsx');
logger.setLevel(env.logLevel);


const validSelectedNavTab = ['main-project-overview', 'main-about', 'main-project', 'main-profile', 'search-projects', 'main-selected-project-view'] as const;
type SelectedNavTab = typeof validSelectedNavTab[number];

interface UIProfile {
    userMessage: jotouiutils.UserMessage;
}

interface UIOwnProjectList {
    pid: jotoTypes.ValidPidValues,
    userMessage: jotouiutils.UserMessage;
}

interface SearchProjectsPage {
    filterValueProfit: string[];
}

interface SelectedProjectView {
    selectedProject: jotoTypes.ProjectPath | null,
    previousSelectedNavTab: SelectedNavTab | null,
    userNickName: string | null
}

interface UI {
    loggedIn: string | null,
    selectedNavTab: SelectedNavTab,
    profile: UIProfile,
    ownProjectList: UIOwnProjectList,
    projectDetail: jotoTypes.Project | null,
    searchProjects: SearchProjectsPage,
    selectedProjectView: SelectedProjectView
}

export interface JotoUIState {
    ui : UI,
    globalProjectList: jotoTypes.Projects,
    ownProjectList: jotoTypes.Project[]
    profile: jotoTypes.Profile | null,
    rehydrated: boolean
    joto: joto.Joto | null,
    jotoui: JotoUIApi | null
}

const initState : JotoUIState = {
    ui: {
        loggedIn: null,
        selectedNavTab: 'main-project-overview',
        profile: {
            userMessage: null,
        },
        ownProjectList: {
            pid: '00',
            userMessage: null,
        },
        projectDetail: null,
        searchProjects: {
            filterValueProfit: ['yes', 'no'],
        },
        selectedProjectView: {
            selectedProject: null,
            previousSelectedNavTab: null,
            userNickName: null
        }
    },
    globalProjectList: {store: {}, projectPathList: []},
    ownProjectList: [],
    profile: null,
    rehydrated: false,
    joto: null,
    jotoui: null
};

export enum ActionTypes {
    login = 'login',
    logout = 'logout',
    updateProfileMessage = 'updateProfileMessage',
    updateProfile = 'updateProfile',
    updateOwnProjectList = 'updateOwnProjectList',
    updateProjectDetail = 'updateProjectDetail',
    ownProjectListSelectPid = 'ownProjectListSelectPid',
    updateOwnProjectListMessage = 'updateOwnProjectListMessage',
    updateGlobalProjectList = 'updateGlobalProjectList',
    navTabSelect = 'navTabSelect',
    singleProjectUpdate = 'singleProjectUpdate',
    updateSearchFilter = 'updateSearchFilter',
    showProjectDetailPage = 'showProjectDetailPage',
}

// const actionTypes = ['login', 'logout', 'updateProfileMessage', 'updateProfile', 'updateOwnProjectList', 'ownProjectListSelectPid', 'updateOwnProjectListMessage', 'updateGlobalProjectList', 'navTabSelect'] as const;
//const actionTypes = [ActionTypes.login, ActionTypes.logout, ActionTypes.updateProfileMessage, ActionTypes.updateProfile, ActionTypes.updateOwnProjectList, ActionTypes.ownProjectListSelectPid, ActionTypes.updateOwnProjectListMessage, ActionTypes.updateGlobalProjectList, ActionTypes.navTabSelect] as const;
// type A = typeof actionTypes[number]

// type ActionTypeStrings = keyof typeof ActionTypes;

// interface Action {
//     // type: ActionTypeStrings
// }

interface LoginAction { // extends Action
    type: ActionTypes.login,
    value: string
}

interface LogoutAction { // extends Action
    type: ActionTypes.logout,
}

interface UpdateProfileMessageAction { // extends Action
    type: ActionTypes.updateProfileMessage,
    value: string | null | Error
}

interface UpdateProfileAction { // extends Action
    type: ActionTypes.updateProfile,
    value: jotoTypes.Profile | null
}

interface UpdateOwnProjectListAction { // extends Action
    type: ActionTypes.updateOwnProjectList
    value: jotoTypes.Project[]
}

interface UpdateProjectDetailAction { // extends Action
    type: ActionTypes.updateProjectDetail,
    value: jotoTypes.Project | null
}

interface OwnProjectListSelectPidAction { // extends Action
    type: ActionTypes.ownProjectListSelectPid,
    value: jotoTypes.ValidPidValues
}

interface UpdateOwnProjectListMessageAction { // extends Action
    type: ActionTypes.updateOwnProjectListMessage,
    value: string | null | Error
}

interface UpdateGlobalProjectListAction { // extends Action
    type: ActionTypes.updateGlobalProjectList,
    value: jotoTypes.Projects
}

interface NavTabSelectAction { // extends Action
    type: ActionTypes.navTabSelect,
    value: SelectedNavTab
}

interface SingleProjectUpdateAction { // extends Action
    type: ActionTypes.singleProjectUpdate,
    value: jotoTypes.Project
}

interface RehydrateAction {
    type: typeof REHYDRATE,
    payload: any
}

interface UpdateSearchFilterAction { // extends Action
    type: ActionTypes.updateSearchFilter,
    value: string[]
}

interface ShowProjectDetailPageAction {
    type: ActionTypes.showProjectDetailPage,
    value: jotoTypes.ProjectPath | null
}

type Action = LoginAction | LogoutAction | UpdateProfileMessageAction | UpdateProfileAction | UpdateOwnProjectListAction | OwnProjectListSelectPidAction | UpdateOwnProjectListMessageAction | UpdateGlobalProjectListAction | NavTabSelectAction | SingleProjectUpdateAction | RehydrateAction |
    UpdateProjectDetailAction | UpdateSearchFilterAction | ShowProjectDetailPageAction;

function noop() : void {}

const ho_reducer = (cb :  () => void ) => (state : JotoUIState = initState , action : Action) : JotoUIState  => {
    // logger.debug('reducer', state, action);

    switch(action.type) {
        case ActionTypes.login:
            const uid = action.value;

            //const user = firebase.auth().currentUser;
            //joto.login(uid, publicProfileUpdateListener);
            return produce(state, draft => {
                draft.ui.loggedIn = uid;
            });
        case ActionTypes.logout:
            return produce(state, draft => {
                draft.ui.loggedIn = null;
                draft.ui.selectedNavTab = 'main-project-overview';
            });
        case ActionTypes.updateProfileMessage:
            return produce(state, draft => {
                draft.ui.profile.userMessage = action.value;
            });
        case ActionTypes.updateProfile:
            return produce(state, draft => {
                let profile = state.profile;
                if(action.value)
                    draft.profile = {...profile, ...action.value};
                else
                    draft.profile = null;
            });
        case ActionTypes.updateOwnProjectList:
            return produce(state, draft => {
                draft.ownProjectList = action.value;
            });
        case ActionTypes.ownProjectListSelectPid:
            return produce(state, draft => {
                draft.ui.ownProjectList.pid = action.value;
            });
        case ActionTypes.updateOwnProjectListMessage:
            return produce(state, draft => {
                draft.ui.ownProjectList.userMessage = action.value;
            });
        case ActionTypes.updateGlobalProjectList:
            return produce(state, draft => {
                draft.globalProjectList = action.value;
            });
        case ActionTypes.navTabSelect:
            return produce(state, draft => {
                draft.ui.selectedNavTab = action.value;
            });
        case ActionTypes.singleProjectUpdate:
            return produce(state, draft => {
                const uid = action.value.uid;
                const pid = action.value.pid;
                draft.globalProjectList.store = merge(draft.globalProjectList.store, {[uid]: {[pid]: action.value}});
            });
        case REHYDRATE:
            const r = produce(state, draft => {
                // noinspection JSUnusedAssignment
                draft = merge(draft, {...action.payload, rehydrated: true})
            });
            cb();
            // (async () => {
            //     await sleep(50);
            //     cb();
            // }) ();
            return r;
        case ActionTypes.updateProjectDetail:
            return produce(state, draft => {
                draft.ui.projectDetail = action.value;
            });
        case ActionTypes.updateSearchFilter:
            return produce(state, draft => {
                draft.ui.searchProjects.filterValueProfit = action.value;
            });
        case ActionTypes.showProjectDetailPage:
            return produce(state, draft => {
                draft.ui.selectedProjectView.selectedProject = action.value;
                if(action.value == null)
                    draft.ui.selectedProjectView.previousSelectedNavTab = null;
                else
                    draft.ui.selectedProjectView.previousSelectedNavTab = state.ui.selectedNavTab;
            });
        default:
            return state;
    }
};

//function reducer(state : JotoUIState = initState , action : Action) : JotoUIState {


declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION__: any;
        fnNavbarSupportedContentShow : () => void;
    }
}

function createReduxInterface(shouldPersist : boolean, rehydratedCallback? : () => void) : {store: redux.Store<JotoUIState, redux.Action>, wrapRedux: any} {
    if(!rehydratedCallback)
        rehydratedCallback = noop;
    const reducer = ho_reducer(rehydratedCallback);
    if(shouldPersist) {
        const persistConfig = {
            key: 'root',
            storage: storageSession,
            stateReconciler: autoMergeLevel2,
            blacklist: ['joto', 'jotoui']
        };
        const persistentReducer = persistReducer(persistConfig, reducer);
        const store = redux.createStore(
            persistentReducer,
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        );
        const persistor = persistStore(store);
        const wrapRedux = (input : any) => <ReduxProvider store={store}><PersistGate loading={null} persistor={persistor}>
            <SmoothUINormalize/>
            {input}
            </PersistGate></ReduxProvider>;
        return {store, wrapRedux};
    } else {
        const store = redux.createStore(
            reducer,
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        );
        const wrapRedux = (input : any) => <ReduxProvider store={store}>
            <SmoothUINormalize/>
            {input}
            </ReduxProvider>;
        return {store, wrapRedux};
    }
}

function isValidSelectedNavTab(input : any) : input is SelectedNavTab {
    return validSelectedNavTab.includes(input);
}

// export const {store, wrapRedux} = createReduxInterface(true);

class JotoUIApi {
    constructor(shouldPersist : boolean, rehydratedCallback? : () => void) {
        initState.jotoui = this;
        const {store, wrapRedux} = createReduxInterface(shouldPersist, rehydratedCallback);
        this.store = store;
        this.wrapRedux = wrapRedux;
    }

    store : redux.Store<JotoUIState, redux.Action>;
    wrapRedux : (input : any) => JSX.Element;

    [ActionTypes.login] = (uid : string) => {
        const action : LoginAction = {
            type: ActionTypes.login,
            value: uid
        };
        this.store.dispatch(action);
    };

    [ActionTypes.logout] = () => {
        const action : LogoutAction = {
            type: ActionTypes.logout
        };
        this.store.dispatch(action);
    };

    [ActionTypes.navTabSelect] = (nt : any) => {
        if(isValidSelectedNavTab(nt)) {
            const action : NavTabSelectAction = {
                type: ActionTypes.navTabSelect,
                value: nt
            };
            this.store.dispatch(action);
        } else {
            throw new Error('You are trying to select a nav-tab that does not exist : "' + nt + '" : ' + JSON.stringify(validSelectedNavTab));
        }
        window.fnNavbarSupportedContentShow();
    };

    [ActionTypes.updateProfileMessage] = (message : string | null | Error) => {
        const action : UpdateProfileMessageAction = {
            type: ActionTypes.updateProfileMessage,
            value: message
        };
        this.store.dispatch(action);
    };

    [ActionTypes.ownProjectListSelectPid] = (pid : jotoTypes.ValidPidValues) => {
        const action : OwnProjectListSelectPidAction = {
            type: ActionTypes.ownProjectListSelectPid,
            value: pid
        };
        this.store.dispatch(action);
    };

    [ActionTypes.updateGlobalProjectList] = (projects : jotoTypes.Projects) => {
        const action : UpdateGlobalProjectListAction = {
            type: ActionTypes.updateGlobalProjectList,
            value: projects
        };
        this.store.dispatch(action);
    };

    [ActionTypes.updateOwnProjectList] = (projects : jotoTypes.Project[]) => {
        const action : UpdateOwnProjectListAction = {
            type: ActionTypes.updateOwnProjectList,
            value: projects
        };
        this.store.dispatch(action);
    };

    [ActionTypes.updateOwnProjectListMessage] = (message : string | null | Error) => {
        const action : UpdateOwnProjectListMessageAction = {
            type: ActionTypes.updateOwnProjectListMessage,
            value: message
        };
        this.store.dispatch(action);
    };

    [ActionTypes.updateProfile] = (profile : jotoTypes.Profile | null) => {
        const action : UpdateProfileAction = {
            type: ActionTypes.updateProfile,
            value: profile
        };
        this.store.dispatch(action);
    };

    [ActionTypes.singleProjectUpdate] = (project : jotoTypes.Project) => {
        const action : SingleProjectUpdateAction = {
            type: ActionTypes.singleProjectUpdate,
            value: project
        };
        this.store.dispatch(action);
    };

    [ActionTypes.updateProjectDetail] = (project : jotoTypes.Project | null) => {
        const action : UpdateProjectDetailAction = {
            type: ActionTypes.updateProjectDetail,
            value: project
        };
        this.store.dispatch(action);
    };

    [ActionTypes.updateSearchFilter] = (value : string[]) => {
        const action : UpdateSearchFilterAction = {
            type: ActionTypes.updateSearchFilter,
            value: value
        };
        this.store.dispatch(action);
    };

    [ActionTypes.showProjectDetailPage] = (projectPath : jotoTypes.ProjectPath | null) => {
        // noinspection TypeScriptValidateJSTypes
        (async () => {
            await jotouiutils.sleep(0);
            if((window as any).$) {
                (window as any).$('#main-selected-project-modal-view').modal('show');
            }
        })();
        /*
        let previousSelectedNavTab = this.store.getState().ui.selectedProjectView.previousSelectedNavTab;
        if(previousSelectedNavTab == null || previousSelectedNavTab === 'main-selected-project-view')
            previousSelectedNavTab = 'main-project-overview';

        if(projectPath == null)
            this.navTabSelect(previousSelectedNavTab);
        else
            this.navTabSelect('main-selected-project-view');
         */
        const action : ShowProjectDetailPageAction = {
            type: ActionTypes.showProjectDetailPage,
            value: projectPath
        };
        this.store.dispatch(action);
    };

    async like(path : jotoTypes.ProjectPath, value : boolean) {
        const loggedIn = this.store.getState().ui.loggedIn;
        if(!loggedIn)
            this.failedMessage.apply(this, likeNotLoggedInMessage);
        const joto = this.store.getState().joto;
        if(joto && loggedIn)
            await joto.like(path, value);
    }

    async likeToggle(path : jotoTypes.ProjectPath) {
        const up = this.store.getState().globalProjectList.store[path.uid];
        if(up == null)
            throw new Error(`JotoUIApi.likeToggle: project.uid: ${path.uid} does not exist.`);
        const p = up[path.pid];
        if(p == null)
            throw new Error(`JotoUIApi.likeToggle: project.uid, project.pid: ${path.uid}, ${path.pid} does not exist.`);
        this.like(path, !p.like);
    }

    projectFromPath(path : jotoTypes.ProjectPath) : jotoTypes.Project | null {
        return joto.projectFromStoreAndPath(this.store.getState().globalProjectList.store, path);
    }

    // https://github.com/teodosii/react-notifications-component
    addNotification(title: string, message: string, type : "success" | "danger" | "info" | "default" | "warning" = "default", duration?: number) {

        let dismiss ;
        if(duration) {
            // @ts-ignore
            dismiss = {
                duration,
                onScreen: false,
                pauseOnHover: true,
                showIcon: true
            }
        }

        const notification = {
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-center",
            animationIn: [],
            animationOut: [],
            dismiss,
            width: 640
        };

        reactNotificationsComponentStore.addNotification(notification);
    }

    successMessage(title: string, message: string, duration = successNotificationTimeout) {
        this.addNotification(title, message, "success", duration);
    }

    failedMessage(title: string, message: string, duration = failureNotificationTimeout) {
        this.addNotification(title, message, "danger", duration);
    }
}

export {JotoUIApi};
